import { UnitConversionService } from "../../services/UnitConversionService.ts";
import { Product, QuantityUnit, RecipeIngredient } from "utils/grocyApi.ts";

function isDiscreteUnit(unit?: QuantityUnit): boolean {
  if (!unit) return false;
  return unit.name === "Pack" || unit.name === "Piece";
}

export function getRecipeShoppingListAmount(
  ingredient: RecipeIngredient,
  product: Product,
  stockUnit: QuantityUnit | undefined,
  conversionService: UnitConversionService | null,
): number {
  if (ingredient.only_check_single_unit_in_stock === 1) {
    return 1;
  }

  const convertedAmount = conversionService?.convertAmount(
    ingredient.amount,
    ingredient.qu_id,
    product.qu_id_stock,
    product.id,
  ) ?? ingredient.amount;

  if (isDiscreteUnit(stockUnit)) {
    return Math.max(1, Math.ceil(convertedAmount));
  }

  return convertedAmount;
}
